const WatchlistReducer = (state=[],action)=>{
    if(action.type==='ADD'){
        if(state.find(movie=>movie.id===action.payload.id)){
            const newArr = state.filter(item=>{
                if(item.id===action.payload.id&&(item.title||item.name)===(action.payload.name||action.payload.title)){
                    return null
                }
                return item
            })
            return newArr
        }
        else{
            return [...state,action.payload]
        }
    }
    return state
}

export default WatchlistReducer;